var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5939 27.3417L27.9439 17.9917C28.0856 17.85 28.1861 17.6965 28.2456 17.5313C28.3051 17.366 28.3344 17.1889 28.3335 17C28.3335 16.8111 28.3037 16.634 28.2442 16.4688C28.1847 16.3035 28.0846 16.15 27.9439 16.0083L18.5939 6.65834C18.3342 6.39862 18.0093 6.26309 17.6192 6.25175C17.2292 6.24042 16.8929 6.37595 16.6106 6.65834C16.3272 6.91806 16.1794 7.24295 16.1671 7.633C16.1549 8.02306 16.2909 8.35928 16.5751 8.64167L23.5168 15.5833H7.68556C7.28417 15.5833 6.94748 15.7193 6.67547 15.9913C6.40347 16.2633 6.26795 16.5996 6.26889 17C6.26889 17.4014 6.40442 17.7381 6.67547 18.0101C6.94653 18.2821 7.28322 18.4176 7.68556 18.4167H23.5168L16.5751 25.3583C16.3154 25.6181 16.1794 25.9486 16.1671 26.35C16.1549 26.7514 16.2909 27.0819 16.5751 27.3417C16.8349 27.625 17.1654 27.7667 17.5668 27.7667C17.9682 27.7667 18.3106 27.625 18.5939 27.3417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/slider-arrow.97f79f604a175c16be6cf7af7929f4bd.svg";
export { ForwardRef as ReactComponent };